import { render, staticRenderFns } from "./MaterialFormDialog.vue?vue&type=template&id=2ffb2c20&scoped=true&"
import script from "./MaterialFormDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb2c20",
  null
  
)

export default component.exports